import Config from 'conf';
import Logger from 'data/common/Logger';
import bindSocketEvents from './binds';

export default socketMiddleware => {
    bindSocketEvents(socketMiddleware);
    let socketEmit = socketMiddleware.socketEmit.bind(socketMiddleware);
    let socketOn = socketMiddleware.socketOn.bind(socketMiddleware);
    return {
        refreshBox: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let refreshBoxFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('boxSysInfo', refreshBoxFeedback);
                        const { time_diff: timeDiff, dns_resolv: dnsResolv, free_space: freeSpace, zwave_status: zwaveStatus, version } = args;
                        if (
                            timeDiff === undefined ||
                            dnsResolv === undefined ||
                            freeSpace === undefined ||
                            zwaveStatus === undefined ||
                            version === undefined
                        ) {
                            Logger.debug(`Arguments manquants sur l'envent socket boxSysInfo : "${JSON.stringify(args)}"`);
                            return reject(new Error('empty_args'));
                        }
                        return resolve();
                    }
                };
                socketOn('boxSysInfo', refreshBoxFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('boxSysInfo', refreshBoxFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_long_socket_order);

                socketEmit('getBoxSysInfo', { fheCenter_mac });
            });
        },
        updateBox: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let updateBoxFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('updateBoxFeedback', updateBoxFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('updateBoxFeedback', updateBoxFeedback);

                let updateBoxSysInfoFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('boxSysInfo', updateBoxSysInfoFeedback);
                        if (args.version) return resolve(args.version);
                        return reject(new Error('notUpdated'));
                    }
                };
                socketOn('boxSysInfo', updateBoxSysInfoFeedback);

                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('updateBoxFeedback', updateBoxFeedback);
                    socketMiddleware.off('boxSysInfo', updateBoxFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_long_socket_order);

                socketEmit('updateBox', { fheCenter_mac });
            });
        },
        restartBox: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let restartBoxFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('restartBoxFeedback', restartBoxFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('restartBoxFeedback', restartBoxFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('restartBoxFeedback', restartBoxFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('restartBox', { fheCenter_mac });
            });
        },
        startVpn: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let startVpnFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('startBoxVPNFeedback', startVpnFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('startBoxVPNFeedback', startVpnFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('startBoxVPNFeedback', startVpnFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('startBoxVPN', { fheCenter_mac });
            });
        },
        stopVpn: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let stopVpnFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('stopBoxVPNFeedback', stopVpnFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('stopBoxVPNFeedback', stopVpnFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('stopBoxVPNFeedback', stopVpnFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('stopBoxVPN', { fheCenter_mac });
            });
        },
        enableZway: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let enableZwayFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('enableZwayFeedback', enableZwayFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('enableZwayFeedback', enableZwayFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('enableZwayFeedback', enableZwayFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('enableZway', { fheCenter_mac });
            });
        },
        disableZway: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let disableZwayFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('disableZwayFeedback', disableZwayFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('disableZwayFeedback', disableZwayFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('disableZwayFeedback', disableZwayFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('disableZway', { fheCenter_mac });
            });
        },
        deleteConfigOverride: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let deleteConfigOverrideFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('deleteConfigOverrideFeedback', deleteConfigOverrideFeedback);
                        if (args.success) return resolve();
                        else reject(new Error(args.error));
                    }
                };
                socketOn('deleteConfigOverrideFeedback', deleteConfigOverrideFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('deleteConfigOverrideFeedback', deleteConfigOverrideFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('deleteConfigOverride', { fheCenter_mac });
            });
        },
        changeUpgradeStatus: function(fheCenter_mac, action) {
            return new Promise((resolve, reject) => {
                let changeUpgradeStatusStatusFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('feedbackAutoUpgrade', changeUpgradeStatusStatusFeedback);
                        if (args.action && args.error === null) return resolve();
                        else reject(args.error);
                    }
                };
                socketOn('feedbackAutoUpgrade', changeUpgradeStatusStatusFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('feedbackAutoUpgrade', changeUpgradeStatusStatusFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('autoUpgrade', { fheCenter_mac, action });
            });
        },
        configureTendaRouter: function(fheCenter_mac, boxId) {
            return new Promise((resolve, reject) => {
                let configureTendaRouterFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('configureTendaRouter', configureTendaRouterFeedback);
                        if (args.res === 'success') return resolve(args.SSID);
                        return reject(args.error);
                    }
                };
                socketOn('configureTendaRouter', configureTendaRouterFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('configureTendaRouter', configureTendaRouterFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_long_socket_order);

                socketEmit('configureTendaRouter', { fheCenter_mac, boxId });
            });
        },
    };
};



// WEBPACK FOOTER //
// ./environments/genericEnv/eventsSocket/Box/index.js